import { CommonService } from './../../../services/utils/common.service';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { StoreCommonService } from 'app/services/store/store-common.service';
import { CustomerCardListModel } from './../../../models/customer-cards.model';
import { mgCustomer, CustomerBasicInfo } from './../../../models/customer.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Rx';
import { CustomerListModel } from '../../../models/customer.model';
import { Permission, PermissionConfiguration, ApiMethods } from '../../../models/permission.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { CustomerInfoService } from '../../../services/customer/customerinfo.service';
import { CustomersService } from '../../../services/customer/customers.service';
import { SourceSystemService } from '../../../services/source-system/source-system.service';
import { PermsService } from '../../../services/utils/perms.service';
import * as FileSaver from 'file-saver';
import { Report } from 'app/models/report.model';
import { exit } from 'process';
import { LoyaltyReservationsService } from 'app/services/loyalty/loyalty-reservations.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { CustomerOblivionService } from 'app/services/customer/customer-oblivion.service';
import { ConfirmationService, MessageService } from 'primeng/primeng';

declare var Stimulsoft: any;
declare var $: any;

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css'],
  providers: [CustomersService, CustomerInfoService]
})
export class CustomerListComponent implements OnInit {

  errors: Array<any>;
  customerModal: any;
  customers: Array<CustomerListModel>;
  showDeleteModal: boolean;
  showInfoModal: boolean;
  //showUploadModal: boolean = false;
  showBarcodeModal: boolean = false;
  srcBarcode: SafeResourceUrl = null;
  datasetChange = false;
  columsTitles: any;
  userInsertInfo: any;
  userUpdateInfo: any;
  userDeleteInfo: any;
  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  translations: any;
  customerHostIdModuli: string = "";
  // Permette la visualizzazione della lista clienti
  public customerPermission: Permission;
  public maxChars: number;

  public customerPermissions: Array<Permission>;
  public loyaltyPermissions: Array<Permission>;

  // Disabilita il filtraggio della table per singola colonna
  public staticTable: boolean;
  public staticTableCheck: PermissionConfiguration;

  // Visualizza tasto download file Excel
  public customerExportExcelPermission: boolean;
  public customerExportExcelPermissionCheck: PermissionConfiguration;

  // Abilita il download del file Excel
  public customerDownloadPermission: boolean;
  public customerDownloadPermissionCheck: PermissionConfiguration;

  // Abilita il pulsante per generare il report cliente
  public customerMgPermission: boolean;
  public customerMgPermissionCheck: PermissionConfiguration;

  // Abilita il pulsante info
  public customerInfoBtnPermission: boolean;
  public customerInfoBtnPermissionCheck: PermissionConfiguration;

  // Abilita tasti saldi
  public reservationPermission: boolean;
  public loyaltyReservationPermissionCheck: PermissionConfiguration;

  // Abilitia il pulsante per obliare il cliente
  public customerOblivionBtnPermission: boolean;
  public customerOblivionPermissionCheck: PermissionConfiguration;


  totalRecords = 0;
  sortO: number;
  sortF: string;
  statusFilter: any;
  listTypeCompany: Array<{label: string, value: string}>;
  listStates: Array<{label: string, value: string}>;
  listSourceSystem: Array<{label: string, value: string}>;

  selectedCustomerHostId = null;
  showExtDialog = false;

  extSearchResult: any;

  show = {
    report: false
  }
  viewer: any;
  pdfReport: Report;

  dateFilter = KontableComponent.DateFilter;
  @ViewChild('table') private kontable: KontableComponent;

  constructor(
    private router: Router,
    private translate: TranslateService,
    public customerService: CustomersService,
    private permissionService: PermsService,
    private svcSourcesystems: SourceSystemService,
    private srvCustomer: CustomerInfoService,
    private srvCustomerOblivion: CustomerOblivionService,
    private srvConfirmation: ConfirmationService,
    private srvMessage: MessageService,
    private srvStoreCommon: StoreCommonService,
    public srvCalendar: CalendarTranslateService,
    private srvLoyaltyReservations: LoyaltyReservationsService,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private srvCommon: CommonService
  ) {
    this.customerService.setFirstList();

    this.staticTableCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-table-static',
      method: ApiMethods.GET
    };

    this.customerExportExcelPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-export-excel',
      method: ApiMethods.GET
    };

    this.customerDownloadPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-download',
      method: ApiMethods.GET
    };

    this.customerMgPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-mg',
      method: ApiMethods.GET
    };

    this.customerInfoBtnPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer',
      method: ApiMethods.DELETE
    };

    this.loyaltyReservationPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'reservation',
      method: ApiMethods.GET
    }

    this.customerOblivionPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-oblivion',
      method: ApiMethods.PUT
    }

    this.maxChars = +sessionStorage.getItem('cardsLength');
  }


  ngOnInit() {

    this.sortO = 1;
    this.sortF = '';
    this.showDeleteModal = false;

    this.errors = [];
    this.listTypeCompany = [];
    this.listStates = [];

    this.staticTable = false;
    this.customerExportExcelPermission = false;
    this.customerDownloadPermission = false;
    this.customerMgPermission = false;
    this.customerInfoBtnPermission = false;
    this.customerOblivionBtnPermission = false;

    const translateObs = this.translate.get([
      'common.all',
      'common.company',
      'common.physicalPerson',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'reportMg.card_title',
      'reportMg.name_title',
      'reportMg.surname_title',
      'reportMg.fiscalcode_title',
      'reportMg.birthdate_title',
      'reportMg.email_title',
      'reportMg.cellphone_title',
      'reportMg.street_title',
      'reportMg.localita_title',
      'reportMg.province_title',
      'reportMg.zipcode_title',
      'reportMg.informativa_title',
      'reportMg.consenso1_title3',
      'reportMg.consenso2_title3',
      'reportMg.consenso_title_yes',
      'reportMg.consenso_title_no',
      'reportMg.currentdate_title',
      'reportMg.sign_title'
    ]);

    const permissionObs = this.permissionService.getPermission({ms_base: 'koncentro-customers', operation: 'customer'});
    const permissionsObs = this.permissionService.getPermissions({ms_base: 'koncentro-customers', operation: 'customer'});
    const loyaltyPermission = this.permissionService.getLoyaltyPermission();

    const sourceSystemObs = this.svcSourcesystems.getList();

    Observable.zip(
      translateObs,
      permissionObs,
      permissionsObs,
      sourceSystemObs,
      loyaltyPermission
      /*
      obStaticTableCheck,
      obCustomerExportExcelPermCheck,
      obCustomerDownloadPermCheck,
      obCustomerMgPermissionCheck,
      obCustomerInfoBtnPermissionCheck
      */
    ).subscribe(([
      t,
      permission,
      permissions,
      sourceSystemList,
      resLoyaltyPermission
      /*
      resStaticTableCheck,
      resCustomerExportExcelPermCheck,
      resCustomerDownloadPermCheck,
      resCustomerMgPermissionCheck,
      resCustomerInfoBtnPermissionCheck
      */
    ]) => {
      this.translations = t;
      this.listTypeCompany.push({label: t['common.all'], value: null});
      this.listTypeCompany.push({label: t['common.company'], value: 'S'});
      this.listTypeCompany.push({label: t['common.physicalPerson'], value: 'N'});

      this.listStates.push({label: t['common.all'], value: '-1'});
      this.listStates.push({label: t['common.status_notDeleted'], value: '0'});
      this.listStates.push({label: t['common.status_onlyDeleted'], value: '1'});

      this.customerPermission = permission;
      this.reloadTableWithParams();
      this.customerPermissions = permissions;
      this.loyaltyPermissions = resLoyaltyPermission;
      this.statusFilter = '0';

      this.staticTable = this.permissionService.checkPermission(this.customerPermissions,this.staticTableCheck);
      this.customerExportExcelPermission =  this.permissionService.checkPermission(this.customerPermissions,this.customerExportExcelPermissionCheck);
      this.customerDownloadPermission = this.permissionService.checkPermission(this.customerPermissions,this.customerDownloadPermissionCheck);
      this.customerInfoBtnPermission = this.permissionService.checkPermission(this.customerPermissions,this.customerInfoBtnPermissionCheck);
      this.customerMgPermission =  this.permissionService.checkPermission(this.customerPermissions,this.customerMgPermissionCheck);
      this.reservationPermission = this.permissionService.checkPermission(this.loyaltyPermissions,this.loyaltyReservationPermissionCheck);
      this.customerOblivionBtnPermission = this.permissionService.checkPermission(this.customerPermissions, this.customerOblivionPermissionCheck);
      this.listSourceSystem = [];
      this.listSourceSystem.push({label: t['common.all'], value: null});
      sourceSystemList.forEach(ss => {
        this.listSourceSystem.push(
          {
            label: ss.name,
            value: ss.name
          }
        )
      })
    });
  }
  reloadTableWithParams(): void {
    if (this.activatedRoute.snapshot.queryParams['customerCode']) {
      var self = this;
      let dataQuery = {
        query: {
          condition: "and",
          rules: [{
            field: 'h.host_id',
            operator: '=',
            value: this.activatedRoute.snapshot.queryParams['customerCode']
          }]
        },
        offset: 0,
        limit: 10
      }
      setTimeout(() => {
        if(self.kontable !== undefined){
          self.kontable.filter = {
            limit: 10,
            offset: 0,
            search: [{
              key: 'customerCode',
              value: this.activatedRoute.snapshot.queryParams['customerCode'],
              filterType: '='
            }]
          }
          self.kontable.columns.customerCode = this.activatedRoute.snapshot.queryParams['customerCode'];
        }
        $('.field-customerCode input').val(this.activatedRoute.snapshot.queryParams['customerCode']);
      }, 100);
      this.sendExtSearchQuery(dataQuery);
    }
  }

  editCustomer(customer) {
    if (customer.flg_company === 'S') {
      if (customer.customer_id) {
        this.router.navigate(['/customer-company', customer.id, customer.customer_id]);
      } else {
        this.router.navigate(['/customer-company', customer.id]);
      }
    } else {
      if (customer.customer_id) {
        this.router.navigate(['/customers-details', customer.id, customer.customer_id]);
      } else {
        this.router.navigate(['/customers-details', customer.id]);
      }
    }
  }

  deleteCustomer(customer) {
    this.customerService.deleteCustomer(customer).subscribe(() => {
      this.customerModal = undefined;
      this.datasetChange = true;
    });
  }

  recoverCustomer(customer) {
    this.customerService.recoverCustomer(customer).subscribe(() => {
      this.datasetChange = true;
    });
  }

  onShowExtClick(host_id) {
    this.showExtDialog = true;
    this.selectedCustomerHostId = host_id;
  }
  downloadExcel(filters) {
    this.customerService.getExcelFilename(filters).subscribe(
      filename => {
        if (this.customerDownloadPermission) {
          this.customerService.downloadExcel(filename).subscribe(res => {
            FileSaver.saveAs(res, filename);
          })
        } else {
          return;
        }
      },
      error => console.error(error)
    );
  }

  sendExtSearchQuery(event) {
    /*
      Azzero totalRecords perchè, in caso di svuotamento della table e successiva
      ripetizione della medesima ricerca, il valore non risulterebbe aggiornato e,
      di conseguenza, causerebbe errori di paginazione
    */
    this.totalRecords = 0;
    const params = {query: event.query, offset: event.offset, limit: event.limit};
    if (event.sortField && event.sortDir) {
      Object.assign(params, {sortField: event.sortField, sortDir: event.sortDir});
    }
    this.customerService.sendExtSearchQuery(params).subscribe(res => {
      this.extSearchResult = res.data;
      this.totalRecords = res.metadata.total;
    });
  }

  goToCustomerBalance(event) {
    if (event.flg_state !== '1') {
      this.router.navigate([`loyalty/balance/${event.customer_id}`]);
    }
  }

  onClickVisualizzaBarcode(cardNo: string) {
    var self = this;
    self.srcBarcode = null;
    let newBarcodeCardNo: string = cardNo;
    if(cardNo.length < 13){

      newBarcodeCardNo = this.srvCommon.getCardWithCheckdigit(cardNo);

      /*
      this.srvLoyaltyReservations.getCardCheckDigit(barcodeCardNo).subscribe(res => {
        //console.log('check digit res ', res);
        if(res && res.length == 13){
          barcodeCardNo = res;
        }
      });
      */
    }
    setTimeout(function(){
      self.srcBarcode = self.sanitizer.bypassSecurityTrustResourceUrl(self.getBarcodeImageByCardNo(newBarcodeCardNo));
      self.showBarcodeModal = true;
    },200);
  }

  getBarcodeImageByCardNo(cardNo: string){
    //console.log('cardNo ', cardNo);
    var JsBarcode = require('jsbarcode');
    JsBarcode("#barcode", cardNo, {
      format: "EAN13",
      lineColor: "#000",
      width:2,
      height:40,
      displayValue: true
    });

    var svg = $("#barcode")[0];

    var xml = new XMLSerializer().serializeToString(svg);

    var base64 = 'data:image/svg+xml;base64,' + btoa(xml);

    return base64;
  }
  /*onClickStoricoModuli(customer: any){
    //this.router.navigate(['/customer-upload-mg/'+customer.id]);
    this.customerHostIdModuli = customer.id.toString();
    var self = this;
    setTimeout(function(){
      self.showUploadModal = true;
    },100);

  }
  onCloseCustomerModules(){
    this.customerHostIdModuli = "";
    this.showUploadModal = false;
  }*/


  oblivionCustomer(customerId: number) {
    this.srvConfirmation.confirm({
      header: this.translate.instant('customerOblivion.confirmOblivionHeader'),
      message: this.translate.instant('customerOblivion.confirmOblivionMessage'),
      acceptLabel: 'OK',
      rejectLabel: this.translate.instant('common.cancel'),
      accept: () =>
        this.srvCustomerOblivion.oblivionCustomer(customerId).subscribe(res => {
          this.datasetChange = true;
          this.srvMessage.add({severity: 'success', summary: 'Success', detail: 'Operation success'});
        }),
      rejectVisible: true  
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-list/customer-list.component.ts